class CollectionView extends HTMLElement {
    static ELEMENT_NAME = 'collection-view'
    static EVENTS = {
        sortChanged: 'sort:changed',
        sidebarLinkClicked: 'sidebar:link:clicked'
    }
    static SELECTORS = {
        sortSelect: 'select[data-sort-select]',
        sidebarLinks: '.sidebar a[href]'
    }
    static CLASSES = {
        collectionViewTransition: 'collection-view-transition'
    }
    static MAX_VIEW_TRANSITION_SCROLL_Y = 200

    $elements = {
        sortSelect: null,
        sidebarLinks: null
    }

    supportsViewTransitions = false

    constructor() {
        super()

        this.handleSortingChange = this.handleSortingChange.bind(this)
        this.handleSidebarLinkClick = this.handleSidebarLinkClick.bind(this)

        this.supportsViewTransitions =
            'startViewTransition' in document &&
            window.CSS &&
            CSS.supports &&
            CSS.supports('selector(::view-transition-group(root))')
    }

    init() {
        this.$elements = {
            sortSelect: this.querySelector(CollectionView.SELECTORS.sortSelect),
            sidebarLinks: this.querySelectorAll(CollectionView.SELECTORS.sidebarLinks)
        }

        if (this.$elements.sortSelect) {
            this.$elements.sortSelect.addEventListener('change', this.handleSortingChange)
        }

        this.$elements.sidebarLinks.forEach((link) => {
            link.addEventListener('click', this.handleSidebarLinkClick)
        })
    }

    /**
     * FUNCTIONS
     */
    emit(event, detail) {
        const eventObj = new CustomEvent(event, {
            detail
        })
        this.dispatchEvent(eventObj)
    }

    markCollectionViewTransition() {
        if (!this.supportsViewTransitions) {
            return
        }

        // Cross-document snapshots look awkward when the old page is scrolled
        // deep into the grid but the new sorted/filtered page starts at the top.
        // In that case, keep the real navigation but skip the view transition.
        if (window.scrollY > CollectionView.MAX_VIEW_TRANSITION_SCROLL_Y) {
            return
        }

        try {
            window.sessionStorage.setItem('collectionViewTransition', '1')
            document.documentElement.classList.add(CollectionView.CLASSES.collectionViewTransition)
        } catch (error) {}
    }

    /**
     * EVENTS
     */
    handleSortingChange() {
        this.markCollectionViewTransition()

        this.emit(CollectionView.EVENTS.sortChanged, {
            sortBy: this.$elements.sortSelect.value
        })

        const queryParams = new URLSearchParams(window.location.search)
        queryParams.set('sort_by', this.$elements.sortSelect.value)
        window.location.search = queryParams.toString()
    }

    handleSidebarLinkClick(event) {
        this.markCollectionViewTransition()

        this.emit(CollectionView.EVENTS.sidebarLinkClicked, {
            link: event.currentTarget.href
        })
    }

    /**
     * LIFECYCLE
     */

    connectedCallback() {
        this.init()
    }

    disconnectedCallback() {
        if (this.$elements.sortSelect) {
            this.$elements.sortSelect.removeEventListener('change', this.handleSortingChange)
        }

        this.$elements.sidebarLinks.forEach((link) => {
            link.removeEventListener('click', this.handleSidebarLinkClick)
        })
    }
}

customElements.define(CollectionView.ELEMENT_NAME, CollectionView)
